import { Project } from '@brg/api';
import { FC, useMemo } from 'react';
import styled, { useTheme } from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';
import { AppTester } from 'supporting';
import { GeoLocationCoordsText } from 'shared/pages/projectEdit/styles';
import {ModerationType} from "../../teams/const/ModerationTypes";

const PointWrapper = styled(FlexBox)`
    width: 100%;
    margin-bottom: 24px;
    flex-flow: row-reverse;
    justify-content: flex-end;
    place-items: center;

    svg {
        margin-right: 8px;
    }
`

export const ProjectPoint: FC<{ project: Project}> = ({ project }) => {
    const isGeo = AppTester.isGeograffee();
    const theme = useTheme();

    //@ts-ignore
    const projectPoint = useMemo(() => (project?.tags.find(x => !!x.point)), [project])

    const Coords = useMemo(() => (
        <FInter.SmallTextBoldDiv
        color={theme.projectEdit.locationBoldText}
        style={{ wordBreak: "break-all" }}
      >
        <GeoLocationCoordsText>
            {/*@ts-ignore*/}
        {projectPoint && projectPoint?.point ? projectPoint?.point['latitude'] : 0} &#39;&#39;N 
        </GeoLocationCoordsText>
        <GeoLocationCoordsText>
            {/*@ts-ignore*/}
          {projectPoint && projectPoint?.point ? projectPoint?.point['longitude'] : 0}
          &#39;&#39;E
        </GeoLocationCoordsText>
      </FInter.SmallTextBoldDiv>
    ), [projectPoint, theme])


    if (!isGeo || !projectPoint) {
        return null;
    }

    return (
        <PointWrapper>
            {Coords}
            <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="6" fill="#6C7073"/>
                <line x1="6" y1="8.5" x2="6" y2="20" stroke="#6C7073" strokeWidth="2"/>
            </svg>
        </PointWrapper>
    )
}import { Project } from '@brg/api';
import { FC, useMemo } from 'react';
import styled, { useTheme } from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';
import { AppTester } from 'supporting';
import { GeoLocationCoordsText } from 'shared/pages/projectEdit/styles';
import {ModerationType} from "../../teams/const/ModerationTypes";

const PointWrapper = styled(FlexBox)`
    width: 100%;
    margin-bottom: 24px;
    flex-flow: row-reverse;
    justify-content: flex-end;
    place-items: center;

    svg {
        margin-right: 8px;
    }
`

export const ProjectPoint: FC<{ project: Project}> = ({ project }) => {
    const isGeo = AppTester.isGeograffee();
    const theme = useTheme();

    //@ts-ignore
    const projectPoint = useMemo(() => (project?.tags.find(x => !!x.point)), [project])

    const Coords = useMemo(() => (
        <FInter.SmallTextBoldDiv
        color={theme.projectEdit.locationBoldText}
        style={{ wordBreak: "break-all" }}
      >
        <GeoLocationCoordsText>
            {/*@ts-ignore*/}
        {projectPoint && projectPoint?.point ? projectPoint?.point['latitude'] : 0} &#39;&#39;N 
        </GeoLocationCoordsText>
        <GeoLocationCoordsText>
            {/*@ts-ignore*/}
          {projectPoint && projectPoint?.point ? projectPoint?.point['longitude'] : 0}
          &#39;&#39;E
        </GeoLocationCoordsText>
      </FInter.SmallTextBoldDiv>
    ), [projectPoint, theme])


    if (!isGeo || !projectPoint) {
        return null;
    }

    return (
        <PointWrapper>
            {Coords}
            <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="6" fill="#6C7073"/>
                <line x1="6" y1="8.5" x2="6" y2="20" stroke="#6C7073" strokeWidth="2"/>
            </svg>
        </PointWrapper>
    )
}